export function BuyerTrends() {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
      <h3 className="text-sm font-semibold text-slate-200 mb-1">Buyer Call Volume — Last 14 Days</h3>
      <p className="text-xs text-slate-500 mb-6">Daily inbound call volume by top buyer</p>
      <div className="flex flex-col items-center justify-center py-8 gap-3">
        <span className="text-4xl">📈</span>
        <p className="text-slate-300 font-medium text-sm">Coming soon</p>
        <p className="text-slate-500 text-xs text-center max-w-xs">
          Buyer trend analysis requires historical data aggregation.
        </p>
      </div>
    </div>
  );
}
